module.exports = __webpack_public_path__ + "static/media/1.3b710508.svg";